import { FC, useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

import polaroid from "images/polaroidsection.png";

export interface SectionPolaroidProps {
  className?: string;
}

const SectionPolaroid: FC<SectionPolaroidProps> = ({ className = "" }) => {
  const ref = useRef<HTMLDivElement>(null);
  // Progreso de scroll de la sección: 0 cuando entra, 1 cuando sale
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  // Zoom suave de la imagen al hacer scroll
  const scale = useTransform(scrollYProgress, [0, 1], [1, 1.18]);

  return (
    <div ref={ref} className={`nc-SectionHero3 relative ${className}`} data-nc-id="SectionHero3" id="container-hero3">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="absolute z-10 ml-10 mt-20 flex w-1/2 flex-col"
      >
        <h2 className="text-left text-5xl font-bold text-white [text-shadow:0_2px_14px_rgba(0,0,0,0.65)] sm:text-5xl md:text-5xl lg:text-8xl xl:text-8xl">
          RESERVA TU POLAROID
        </h2>
        <span className="w-80 text-xl text-white [text-shadow:0_2px_10px_rgba(0,0,0,0.7)]">
          Déjate llevar por el mood y llévate inolvidables fotos instantáneas.
        </span>
      </motion.div>

      <div className="relative aspect-w-1 aspect-h-1 overflow-hidden rounded-3xl sm:aspect-w-4 sm:aspect-h-3 lg:aspect-w-12 lg:aspect-h-8 xl:aspect-h-4">
        <motion.img
          id="banner"
          style={{ scale }}
          className="inset-0 h-full w-full object-cover"
          src={polaroid}
          alt="Reserva tu polaroid"
        />
      </div>
    </div>
  );
};

export default SectionPolaroid;
